import { createSlice } from '@reduxjs/toolkit';
import { getLegacyMarcas } from '../legacy/thunk.js';

export const initialState = {
    legacyMarcas: [],
    loading: false,
    error: {},
};

const legacyMarcasSlice = createSlice({
    name: 'legacyMarcas',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyMarcas.fulfilled, (state, action) => {
            state.legacyMarcas = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyMarcas.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyMarcas.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyMarcasSlice.reducer;